const filter_array = [
  {
    label: "Alle",
    value: "all",
  },
  {
    label: "Nur Spezialisten",
    value: "specialists",
  },
  {
    label: "Nur Kompetenzzentren",
    value: "competence_centers",
  },
];

export default filter_array;
